// extracted by mini-css-extract-plugin
export default {"richEditorCustomLink":"RXDuZKDp5kUp4b79Ypvw"};